<template>
  <div class="page-numero-da-sorte">
    <h1 class="page-title" v-html="$config.strings['luckNumber-title']"/>
    <div class="page-description" v-html="$config.strings['luckNumber-description']"/>
    <form class="cpf-form">
      <t-input :error="mensagemDeErro" :label="$config.strings['luckNumber-formField-name-1']" class="cpf-input" v-mask="'###.###.###-##'" :placeholder="$config.strings['luckNumber-formField-name-1-placeholder']" v-model="cpf" @input="resetarErro"/>
      <t-button class="btn-buscar" :size="'lg'" :backgroundColor="$config.colors.secondary" :color="$config.colors.on.secondary" @click.prevent="buscar(cpf)" v-html="$config.strings['luckNumber-formField-btn']"/>
    </form>
    <div class="sorteio-tables-container" v-if="sorteios.length > 0">
      <table class="sorteio-table">
        <tr class="sorteio-table-header">
          <td class="sorteio-table-col" v-html="$config.strings['luckNumber-table-columnName-1']"/>
          <td class="sorteio-table-col" v-html="$config.strings['luckNumber-table-columnName-2']"/>
          <td class="sorteio-table-col" v-html="$config.strings['luckNumber-table-columnName-3']"/>
        </tr>
        <tr class="sorteio-table-row" :key="JSON.stringify(sorteio)" v-for="sorteio in sorteios">
          <td class="sorteio-table-col" v-html="sorteio.numero"/>
          <td class="sorteio-table-col" v-html="sorteio.premio"/>
          <td class="sorteio-table-col" v-html="sorteio.dataSorteio"/>
        </tr>
      </table>
    </div>
    <t-dialog ref="erroDialog">
      <template v-slot:title>
        <span>Ops!</span>
      </template>
      <template v-slot:text>
        <span v-html="$config.strings['luckNumber-request-failed']"/>
      </template>
    </t-dialog>
    <t-loading :visible="loading"/>
  </div>
</template>

<script>
import { TInput, TButton, TDialog, TLoading } from '@/components/base'
import { mask } from 'vue-the-mask'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'page-numero-da-sorte',
  directives: { mask },
  components: { TInput, TButton, TDialog, TLoading },
  filters: {
    dateOnly (value) {
      return value.split(' ')[0]
    }
  },
  data () {
    return {
      cpf: '',
      mensagemDeErro: null,
      loading: false
    }
  },
  computed: {
    ...mapState({
      sorteios: state => state.numeroDaSorte.sort((a, b) => {
        const [aDia, aMes, aAno] = a.dataSorteio.split(' ')[0].split('/')
        const [bDia, bMes, bAno] = b.dataSorteio.split(' ')[0].split('/')
        return +new Date(aAno, aMes, aDia) - +new Date(bAno, bMes, bDia)
      })
    })
  },
  methods: {
    ...mapActions(['getNumeroDaSorte']),
    resetarErro () {
      this.mensagemDeErro = null
    },
    buscar (cpf) {
      this.resetarErro()
      if (this.cpf) {
        const timeout = setTimeout(() => {
          this.loading = true
        }, 250)
        this.getNumeroDaSorte(cpf).then(response => {
          if (response.length === 0) {
            this.mensagemDeErro = this.$config.strings['luckNumber-request-empty']
          }
        }).catch(error => {
          if (error.response.data.message === 'Invalid CPF') {
            this.mensagemDeErro = this.$config.strings['luckNumber-request-invalid']
          } else {
            this.$refs.erroDialog.open()
          }
        }).finally(() => {
          this.loading = false
          clearTimeout(timeout)
        })
      } else {
        this.mensagemDeErro = this.$config.strings['luckNumber-request-inputEmpty']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-numero-da-sorte {
  @include container-element;
  background-color: var(--secondary-light);

  .sorteio-tables-container {
    overflow-x: auto;
    margin-top: 30px;
    background-color: var(--background);

    @include for-size(phone-only) {
      margin-left: -15px;
      margin-right: -15px;
      padding: 0 30px;
      font-size: 15px;
    }
    .sorteio-table {
      border-color: gray;

      .sorteio-table-header {
        background-color: var(--primary);
        color: var(--on-primary);

        & > * {
          color: inherit;
        }
      }
      color: var(--on-primary);
      margin-bottom: 50px;
      min-width: 600px;
      margin-top: 30px;
      border-color: var(--secondary-light);
      width: 100%;
      border: none;
      border-radius: 10px;
      overflow: hidden;

      .sorteio-table-row {
        background-color: #ffffff;

        &:nth-child(odd) {
          background-color: #e2e2e3;
        }
      }

      .sorteio-table-col {
        padding: 30px;
        @include for-size(phone-only) {
          padding: 15px;
        }
    }
    }
  }
  .cpf-form {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    min-height: 200px;
    width: 100%;

    .cpf-input {
      @include for-size(phone-only) {
        width: 100%;
      }
      @include for-size(tablet-portrait-up) {
        width: 50%;
      }
    }

    .btn-buscar {
      height: 40px;
      margin: initial;

      @include for-size(tablet-portrait-up) {
        height: 60px;
        margin-top: 12.5px;
        margin-left: 15px;
      }
    }
  }
}
</style>
